import React, { useEffect, useState } from "react";
import { getAllCollegePagination, getAllCourse, getAllExamPagination } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { createCollegeExam } from "../../Services/CollegeService";

const AddCollegeExam = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        college_id: "",
        exam_id: "",
        min_marks: "",
        max_marks: "",
        type: "",
        course_id: ""
    });
    const [loader, setLoader] = useState(false);
    const [college, setCollege] = useState([]);
    const [exam, setExam] = useState([]);
    const [course, setCourse] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCollegeExam(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllCollegeCall = async () => {
        let { ok, data } = await getAllCollegePagination({});
        if (ok) {
            setCollege(data?.records);
        }
    };

    const getAllCourseCall = async () => {
        let { ok, data } = await getAllCourse({});
        if (ok) {
            setCourse(data?.records);
        }
    };

    const getAllExamCall = async () => {
        let { ok, data } = await getAllExamPagination({});
        if (ok) {
            setExam(data?.records);
        }
    };

    useEffect(() => {
        getAllCollegeCall();
        getAllExamCall();
        getAllCourseCall();
        if (data?.data) {
            const { id, college_id, exam_id, max_marks, min_marks, type, course_id } = data?.data;
            setReqData({ id, college_id, exam_id, max_marks, min_marks, type, course_id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add College And Exam" : "Edit College And Exam"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>College</label>
                                            <select required value={reqData?.college_id} onChange={(e) => handleChange("college_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select College</option>
                                                {college?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Exam</label>
                                            <select required value={reqData?.exam_id} onChange={(e) => handleChange("exam_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Exam</option>
                                                {exam?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Type</label>
                                            <select required value={reqData?.type} onChange={(e) => handleChange("type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Type</option>
                                                <option value={"entrance"}>Entrance</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Min Marks</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Min Marks"
                                                required
                                                value={reqData?.min_marks}
                                                onChange={(e) => handleChange("min_marks", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Max Marks</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Max Marks"
                                                required
                                                value={reqData?.max_marks}
                                                onChange={(e) => handleChange("max_marks", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Course ID</label>
                                            <select required value={reqData?.course_id} onChange={(e) => handleChange("course_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                {course?.map(obj => <option value={obj?.id}>{obj?.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollegeExam;